/**
 * Trigger: tr_creditors_insert
 * Purpose: Update account balances when a creditor is inserted
 * Table: creditors
 * Event: AFTER INSERT
 */
export const TR_CREDITORS_INSERT = `
CREATE TRIGGER tr_creditors_insert
AFTER INSERT ON creditors FOR EACH ROW
BEGIN
  UPDATE account_balances
  SET creditors_amount = creditors_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id;

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_id, new.creditor_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_id, new.creditor_date);

  UPDATE account_daily_balances
  SET creditors_amount = creditors_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id
    AND balance_date = new.creditor_date;

  INSERT OR IGNORE INTO exchange_rates (rate_date, rate, currency_id)
  SELECT new.creditor_date, new.exchange_rate, new.currency_id
  WHERE new.exchange_rate > 0;
END;
`;
